import React from 'react';
import c from 'classnames';

import { WasteIcon } from '@hvcgroep/design-system';
import gtm from '../../../../../shared/helpers/gtm';
import {
  APP_ID,
  WASTE_STREAM_GFT,
  WASTE_STREAM_PAPER,
  WASTE_STREAM_PMD,
  WASTE_STREAM_REST,
} from '../../../../../shared/config/constants';

import './style.scss';
import { useGetWasteStreamsQuery } from '../../../../../shared/store/slices/WebsiteApi';

const CalendarLegend: React.FC = () => {
  const classNames = c('CalendarWidget__Legend');

  const { data: streams } = useGetWasteStreamsQuery(null);

  const legendItems = [
    WASTE_STREAM_REST,
    WASTE_STREAM_PAPER,
    WASTE_STREAM_GFT,
    WASTE_STREAM_PMD,
  ];

  return (
    <div className={classNames}>
      <ul>
        {legendItems.map((wasteStreamId) => (
          <li key={wasteStreamId}>
            <WasteIcon streamId={wasteStreamId} />
            <a
              href={streams?.[wasteStreamId].path}
              onClick={() => {
                gtm.trackUserEvent(String(APP_ID), 'Calendar footer waste stream click', String(streams?.[wasteStreamId].title));
              }}
            >
              {streams?.[wasteStreamId].title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CalendarLegend;
